<template>
  <app-modal
    :modal-id="modalId"
    :title="title"
    :preloader="preloader"
    @submit="submit"
    @close-modal="closeModal"
    modal-size="large"
    modal-alignment="top"
  >
    <template slot="header">
      <h5 class="modal-title">{{ title }}</h5>
      <button
        type="button"
        class="close outline-none"
        data-dismiss="modal"
        aria-label="Close"
      >
        <span>
          <app-icon :name="'x'"></app-icon>
        </span>
      </button>
    </template>

    <template slot="body">
      <app-overlay-loader v-if="preloader" />
      <form
        :class="{ 'loading-opacity': preloader }"
        ref="form"
        :data-url="`performance-evaluations/evaluator/updateDocument`"
      >
        <div class="my-2">
          <div class="form-group justify-content-center align-items-center">
            <h4 v-if="inputs.evaluation_team_performance"><b>El {{typeEvaluator}}</b> ha cargado el documento solicitado</h4>
            <h4 v-if="!inputs.evaluation_team_performance"><b>El {{typeEvaluator}}</b> aún <b>NO</b> ha cargado el documento solicitado</h4>
            <button
              type="submit"
              class="btn btn-success"
              @click.prevent="openTab(inputs, 'evaluation_team_performance')"
              v-if="inputs.evaluation_team_performance"
            >
              <app-icon name="file" />
              {{ $t("view") }}
            </button>
          </div>
          <div v-if="inputs.evaluation_team_performance">
            <label>¿Existe alguna observación?</label>
              <app-input
                type="radio-buttons"
                v-model="is_observation"
                :list="confirm"
              />
          </div>
          <div class="form-group mt-2" v-if="is_observation">
            <label>Observaciones</label>
            <app-input
              type="textarea"
              v-model="inputs.observations"
              placeholder="Ingrese las observaciones"
              :required="true"
            />
          </div>
          
        </div>
      </form>
    </template>

    <template slot="footer">
      <button
        type="button"
        class="btn btn-secondary mr-2"
        data-dismiss="modal"
        @click="closeModal"
      >
        Cerrar
      </button>
      <button v-if="inputs.is_performance && inputs.evaluation_team_performance" type="button" class="btn btn-primary" @click="submit">
        Guardar y Notificar
      </button>
    </template>
  </app-modal>
</template>

<script>
import { FormMixin } from "@/core/mixins/form/FormMixin.js";
import { ModalMixin } from "@/app/Mixins/ModalMixin";



export default {
  name: "ModalEvaluation",
  mixins: [FormMixin, ModalMixin],
  props: {
    modalTitle: String,
    idEvaluator: Number,
    typeEvaluator: String,
  },
  data() {
    return {
      preloader: false,
      loaded: false,
      inputs: {},
      is_observation: 0,
      modalId: "modal-evaluation-edit",
      confirm: [
        {
          id: 0,
          value: "NO",
        },
        {
          id: 1,
          value: "SI",
        },
      ],
    };
  },
  computed: {
    title() {
      return this.modalTitle;
    },
  },
  created() {
    this.infoEvaluator();
  },
  methods: {
    submit() {
      this.inputs.is_observation = this.is_observation;
      this.save(this.inputs);
    },

    afterSuccess(response) {
      this.$toastr.s(this.$t("updated_success"));
    },

    afterError(response) {
      this.$toastr.e(response.data.message);
    },
    infoEvaluator() {
      this.preloader = true;
      let url = `/performance-evaluations/evaluator/showEvaluator/${this.idEvaluator}`;
      this.axiosGet(url).then((response) => {
        this.inputs = response.data;
      }).catch(({ error }) => {
        console.log(error);
      })
      .finally(() => {
        this.preloader = false;
      });
    },
    openTab(obj, fileName) {
      const w = window.open(obj[fileName].path, "_blank");
      w.focus();
    },
  },

};
</script>
<style>

</style>
